module.exports = __webpack_public_path__ + "static/img/icon_xinwen.cb58af82.png";